import VesselDetails from "../../../components/VesselDetails/VesselDetails";

const EnrollVesselPage = () => {
	return <VesselDetails isEnrollVessel={true} isReportTab={false}/>;
};

export default EnrollVesselPage;
